import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import '../../../styles/index.scss';
import { Footer, Header } from '..';

import styles from './InboxMassOfferingsLayout.module.scss';

const InboxMassOfferingsLayout = React.memo(({ children }) => {
  return (
    <>
      <div className={classNames('app h-100 d-flex flex-column', styles.self)}>
        <Header
          description="Skrzynka intencji"
          // customColors={{
          //   primary: '#fcb900',
          //   secondary: '#323433',
          // }}
        />

        <main className="container-lg flex-grow-1 flex-shrink-0 d-flex flex-column mt-5">
          {children}
        </main>

        <div className={styles.footerWrapper}>
          <Footer isWhite />
        </div>
      </div>
    </>
  );
});

InboxMassOfferingsLayout.propTypes = {
  children: PropTypes.node,
};

export default InboxMassOfferingsLayout;
